import { render, staticRenderFns } from "./NoteMobile.vue?vue&type=template&id=5e718daa&scoped=true&"
import script from "./NoteMobile.vue?vue&type=script&lang=js&"
export * from "./NoteMobile.vue?vue&type=script&lang=js&"
import style0 from "./NoteMobile.vue?vue&type=style&index=0&id=5e718daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e718daa",
  null
  
)

export default component.exports